module.exports = __webpack_public_path__ + "img/shopGuide_2c_kr_2.763d9d70.jpg";